/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { TapVersion } from './models';
import { TapStreamReader, TapStreamWriter } from '@iotize/tap/client/impl';

export class TapVersionConverter implements BodyConverter<TapVersion> {
  public encode(
    model: TapVersion,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeTapVersion(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): TapVersion {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readTapVersion();
  }
}
